export var CountryEnum;
(function (CountryEnum) {
    CountryEnum["EC"] = "Ecuador";
    CountryEnum["CO"] = "Colombia";
    CountryEnum["PE"] = "Peru";
    CountryEnum["CL"] = "Chile";
    CountryEnum["MX"] = "Mexico";
})(CountryEnum || (CountryEnum = {}));
